import { FuseAnimate } from "@fuse";
import { withStyles } from "@material-ui/core";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import classNames from "classnames";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ReactTable from "react-table";
import { bindActionCreators } from "redux";
import * as Actions from "./Store/Actions/EmpresaPessoaFormularioActions";

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,

    }
});

class EmpresaPessoaFormularioList extends XAPPComponent {

    state = {
        selectedMenu: null
    };

    componentDidUpdate() {
        if (this.props.EmpresaPessoaFormulario.error) {
            this.props.showMessage({
                message: this.props.EmpresaPessoaFormulario.error,
                variant: "error"
            });
            this.props.EmpresaPessoaFormulario.error = null;
        }
    }

    filterEmpresaPessoaFormulario = () => {
        var obj = [];
        if (this.props.selected !== null) {
            this.props.EmpresaPessoaFormulario.data.forEach(item => {
                if (this.props.selected.id === item.tipo) {
                    obj.push(item);
                }
            });
        }
        else {
            obj = this.props.EmpresaPessoaFormulario.data;
        }
        return obj;
    };

    render() {
        const { EmpresaPessoaFormulario, openEditDialog, xappRouteParams, classes, idparent, changeSelected } = this.props;
        const Columns = [
            {
                Header: "ID",
                accessor: "idpessoaformulario",
                width: 60,
                className: "justify-end"
            },
            {
                Header: "Data",
                accessor: "datainsdescricao",
                width: 150,
                className: "justify-end"
            },
            {
                Header: "Tipo",
                accessor: "tipodescricao",
                className: ""
            },
            {
                Header: "Descrição",
                accessor: "formulario.descricao",
                className: ""
            },
        ];

        return (
            <React.Fragment>
                <FuseAnimate animation="transition.slideUpIn" delay={300}>
                    <ReactTable
                        className={classNames(classes.root, " -striped -highlight border-0")}
                        getTrProps={(state, rowInfo) => {
                            return {
                                className: "cursor-pointer",
                                onClick: () => {
                                    if (rowInfo) {
                                        Promise.all([
                                            changeSelected({ "id": rowInfo.original.tipo })
                                        ]).then(() => openEditDialog(rowInfo.original, xappRouteParams, idparent));
                                    }
                                }
                            };
                        }}
                        data={EmpresaPessoaFormulario.data ? this.filterEmpresaPessoaFormulario() : []}
                        columns={Columns}
                        defaultPageSize={100}
                        noDataText="Não existem registros cadastrados!"
                    />
                </FuseAnimate>
            </React.Fragment>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        //list: Actions.list,
        openEditDialog: Actions.openEditDialog,
        remove: Actions.remove,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ PessoaFormulario }) {
    return {
        EmpresaPessoaFormulario: PessoaFormulario,
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaPessoaFormularioList)));
